/*
 * halal-label/app.js — the page: three tabs over pure modules.
 *
 *   Izin & halal   HalalWizard.decide()      → verdict cards
 *   Nilai gizi     HalalIng.compute()        → ING table (preview = the same
 *                                              items the PDF draws)
 *   Label          HalalLayout.layout()      → label-maker items → LabelRender
 *                  (preview) and LabelPdf + HalalExt.overlay (PDF)
 *
 * The label-maker engine is used as it is (no core edits): its sheets, its
 * renderer, its PDF builder, its fonts. What it does not draw — italics and
 * vector marks — is HalalExt, drawn by both backends from the same numbers.
 *
 * Work survives a crash, a closed tab and F5: window.__toolDraft.editor.
 * Only the label EXPORT is capped (config/tiers.php), keyed by the content of
 * the label — re-exporting the same label the same day is free.
 */
(function () {
    'use strict';

    var C = window.__HALAL || {};
    var SLUG = 'halal-label';
    var T = C.t || {};
    var I = window.HalalIng, R = window.HalalRules, W = window.HalalWizard;
    var L = window.HalalLayout, X = window.HalalExt, LG = window.HalalLogo;
    var ITEMS = C.items || [];
    var MARKS = C.marks || {};
    var FAMILY = '"HL Noto Sans", "Noto Sans", Arial, sans-serif';
    var PALETTE_TEXT = '#000000';
    var RED = '#fc0202';

    function $(id) { return document.getElementById(id); }
    function t(k, v) {
        var s = T[k];
        if (s == null) s = k;
        if (v) for (var n in v) if (Object.prototype.hasOwnProperty.call(v, n)) s = s.split(':' + n).join(String(v[n]));
        return s;
    }
    function esc(s) {
        return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
    }
    function num(v) {
        if (typeof v === 'number') return v;
        var s = String(v == null ? '' : v).trim().replace(/\s+/g, '').replace(',', '.');
        if (!s) return null;
        var n = Number(s);
        return isFinite(n) ? n : null;
    }
    /* Numbers in the INTERFACE follow the page language (__intlLocale: an
       English page says 6.1 pt); the label itself is always Indonesian and
       formats its own figures with a decimal comma (label-layout.js). */
    function fmt(n, d) {
        if (n == null || !isFinite(n)) return '';
        var dec = d == null ? (n % 1 ? 1 : 0) : d;
        try {
            var loc = window.__intlLocale ? window.__intlLocale() : 'id';
            return new Intl.NumberFormat(loc, { minimumFractionDigits: dec, maximumFractionDigits: dec, useGrouping: false }).format(n);
        } catch (_) { return I.fmt(n, dec); }
    }
    function ae(f, extra) {
        try { window.__ae && window.__ae('feature_use', Object.assign({ slug: SLUG, f: f }, extra || {})); } catch (_) {}
    }
    /* The path through the tool, each step once per page view: where people
       stop between «what permit» and «a printed label». Never a name, an
       address, a number of the label — only which step and its shape. */
    var _funnelSeen = {};
    function funnel(stage, extra) {
        if (_funnelSeen[stage]) return;
        _funnelSeen[stage] = 1;
        try { window.__aeFunnel && window.__aeFunnel(stage, extra || {}); } catch (_) {}
        try { window.__stage && window.__stage(stage, extra || {}); } catch (_) {}
    }
    /* Why it did not work, by code: «label does not fit by N mm», «logo is
       the old green MUI mark», «no Kepka kind for this query». */
    function diag(issue, extra) {
        try { window.__aeDiagnostic && window.__aeDiagnostic(Object.assign({ issue: issue }, extra || {})); } catch (_) {}
    }
    function byName(name) {
        for (var i = 0; i < ITEMS.length; i++) if (ITEMS[i].name === name) return ITEMS[i];
        return null;
    }
    function todayIso() {
        if (window.__localYmd) try { return window.__localYmd(); } catch (_) {}
        var d = new Date();
        return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
    }

    /* ── state ─────────────────────────────────────────────────────────── */

    function freshState() {
        return {
            v: 1,
            tab: 'izin',
            wiz: { origin: 'domestic', scale: 'mikro', place: 'home', form: 'solid', storage: 'ambient',
                shelf7: true, special: 'none', readyToEat: false, haram: 'none', porkFacility: false,
                sh: 'no', simple: true },
            ing: { src: 'kepka', kind: '', net: '', unit: 'g', serving: '', urt: '', spp: null,
                format: 'vertical', lab: ['', '', '', '', '', '', ''] },
            label: {
                w: 100, h: 70, preset: '100x70', mode: 'auto', print: 'page', cut: true, sheet: '',
                brand: '', name: '', netValue: '', netUnit: 'g',
                role: 'produced', producer: '', address: '', importer: '', importerAddr: '',
                permit: 'pirt', permitNo: '',
                halal: 'none', shNo: '', logoColor: 'asli', halalH: 13, numberOutside: false,
                markVariant: 'red', markH: 7, bpomShared: false,
                ingredients: '', alOff: [], alForm: 'see', cross: [], crossForm: 'mungkin',
                prodDate: todayIso(), shelf: 180, expMode: 'date', expForm: 'auto', expStyle: 'numeric',
                expSee: 'bagian bawah kemasan', codeMode: 'text', code: '', storage: '',
                sweet: false, aspartame: false, polyol: false,
                ingOn: true, ingFormat: 'auto', qrCurah: false, qrSecondary: false, qrBottle: false,
                ean: '', extra: '', batch: '',
            },
        };
    }

    var S = freshState();
    var logo = null;           // { blob, an, img:{w,h,data}, src (data URL), ratio, verdict }
    var editor = null;         // __toolDraft editor
    var measure = null;
    var lastLayout = null, lastIng = null, lastChecks = [];
    var lastPdf = null;        // { blob, name } of the label PDF just delivered — «Bagikan PDF» sends the same file
    var shot = null;           // { blob, url, key } the label as a picture for a chat

    /* ── fonts & measurement ───────────────────────────────────────────── */

    function familyFor() { return FAMILY; }
    /* Height of the lower-case "o" of the face the PDF embeds, as a fraction
       of the type size — read from the font files themselves (fontTools,
       glyph "o" yMax − yMin / unitsPerEm): NotoSans-Regular 556/1000,
       NotoSans-Bold 566/1000. Pasal 9 is about the PRINTED letter, so the
       number comes from the file that is printed, not from canvas metrics:
       canvas at 100 px rounds 0,556 up to 0,56, and that 0,7 % put the
       allergen statement at "o" = 1,985 mm under a 2 mm rule. */
    var O_RATIO = { r: 0.556, b: 0.566 };
    /* The size solver measures the same words at dozens of trial sizes on every
       keystroke; canvas width is linear in the size (the measurer itself reads
       it at 100 px and scales), so one measurement per word and weight is
       enough. Without the memo a redraw cost 740 ms on a ×4-throttled phone and
       typing a product name lagged a key behind (QA 23.10.2026). Cleared when
       the faces finish loading — widths of a fallback face must not survive. */
    function buildMeasure() {
        var base = window.LabelRender.measurer(familyFor);
        var unit = new Map(), asc = new Map();
        var m = function (text, st) {
            var s = String(text == null ? '' : text);
            var k = (st && st.bold ? 'b' : 'r') + ((st && st.font) || '') + '\u0001' + s;
            var u = unit.get(k);
            if (u === undefined) {
                u = base(s, { font: st && st.font, bold: !!(st && st.bold), size: 1 });
                if (unit.size > 50000) unit.clear();
                unit.set(k, u);
            }
            var ls = (st && st.letterSpacing) || 0;
            return u * ((st && st.size) || 3) + ls * Math.max(0, s.length - 1);
        };
        m.ascentEm = function (st) {
            var k = (st && st.bold ? 'b' : 'r') + ((st && st.font) || '');
            var a = asc.get(k);
            if (a === undefined) { a = base.ascentEm(st); asc.set(k, a); }
            return a;
        };
        m.oRatio = function (st) { return st && st.bold ? O_RATIO.b : O_RATIO.r; };
        m.reset = function () { unit.clear(); asc.clear(); };
        return m;
    }
    function fontsReady() {
        if (!document.fonts || !document.fonts.load) return Promise.resolve();
        return Promise.all([
            document.fonts.load('400 16px "HL Noto Sans"'),
            document.fonts.load('700 16px "HL Noto Sans"'),
        ]).catch(function () {});
    }

    /* ── tabs ──────────────────────────────────────────────────────────── */

    function showTab(tab, user) {
        S.tab = tab;
        ['izin', 'ing', 'label'].forEach(function (k) {
            var b = $('hl-tab-' + k), p = $('hl-p-' + k);
            var on = k === tab;
            if (b) { b.classList.toggle('on', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1; }
            if (p) p.hidden = !on;
        });
        if (tab === 'ing') renderIng();
        if (tab === 'label') renderLabel();
        if (user) { touch(); ae('tab', { tab: tab }); }
        if (user && tab === 'label') funnel('label_open');
    }

    /* ── wizard ────────────────────────────────────────────────────────── */

    function wizardAnswers() {
        var w = S.wiz;
        return {
            origin: w.origin, scale: w.scale, place: w.place, storage: w.storage, shelf7: w.shelf7,
            form: w.form, special: w.special, readyToEat: w.readyToEat, haram: w.haram,
            porkFacility: w.porkFacility, sh: w.sh, simple: w.simple,
        };
    }

    function reflectChoices(root, state) {
        root.querySelectorAll('[data-q]').forEach(function (btn) {
            var q = btn.getAttribute('data-q'), v = btn.getAttribute('data-v');
            var cur = state[q];
            var on = String(cur) === v;
            btn.classList.toggle('on', on);
            btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
    }

    function renderWizard() {
        var w = S.wiz;
        var root = $('hl-p-izin');
        if (!root) return;
        reflectChoices(root, w);
        // questions that only matter in some answers
        var show = function (id, on) { var el = $(id); if (el) el.hidden = !on; };
        show('hl-q-pork', w.haram === 'process');
        show('hl-q-sh', w.haram === 'none');
        show('hl-q-simple', w.haram === 'none' && w.sh !== 'yes' && w.origin !== 'import' && w.scale !== 'besar');
        show('hl-q-place', w.origin !== 'import');
        show('hl-q-ready', w.origin !== 'import');

        var d = W.decide(wizardAnswers());
        var out = $('hl-w-out');
        if (!out) return;
        out.innerHTML = [permitCard(d.permit), halalCard(d.halal), ingCard(d.ing), nutriCard(d.nutri)].join('');
        var ans = $('hl-w-answer');
        if (ans) ans.textContent = t('w_short_' + d.permit.verdict);
        var asub = $('hl-w-answer-sub');
        var subTxt = t('w_sub', { halal: t('w_short_halal_' + (d.halal.mark || 'none')), ing: t('w_short_ing_' + d.ing.verdict) });
        if (asub) asub.textContent = subTxt;
        var live = $('hl-w-live'), liveSub = $('hl-w-live-sub');
        if (live) live.textContent = t('w_short_' + d.permit.verdict);
        if (liveSub) liveSub.textContent = subTxt;
    }

    function card(cls, eyebrow, head, paras, refs) {
        return '<article class="hl-card hl-card--' + cls + '">'
            + '<p class="tc-eyebrow">' + esc(eyebrow) + '</p>'
            + '<p class="hl-card-v">' + esc(head) + '</p>'
            + paras.filter(Boolean).map(function (p) { return '<p class="hl-card-t">' + p + '</p>'; }).join('')
            + (refs && refs.length ? '<p class="hl-card-refs">' + refs.map(esc).join(' · ') + '</p>' : '')
            + '</article>';
    }

    function permitCard(p) {
        var paras = p.reasons.map(function (r) { return esc(t('w_r_' + r)); });
        if (p.verdict === 'pirt') paras.push(esc(t('w_pirt_how')));
        if (p.verdict === 'md') paras.push(esc(t('w_md_how')));
        if (p.verdict === 'ml') paras.push(esc(t('w_ml_how')));
        if (p.verdict === 'none') paras.push(esc(t('w_none_how')));
        return card(p.verdict === 'none' ? 'info' : 'ok', t('w_permit'), t('w_permit_' + p.verdict), paras, p.refs);
    }

    function halalCard(h) {
        var paras = [];
        var cls = 'ok', head;
        if (h.verdict === 'not_halal') {
            head = t(h.mark === 'babi' ? 'w_halal_babi' : 'w_halal_nonhalal');
            paras.push(esc(t('w_r_' + h.reasons[0])));
            paras.push(esc(t('w_halal_exempt')));
            if (h.bpomShared) paras.push(esc(t('w_halal_bpom_shared')));
            cls = 'warn';
        } else if (h.mark === 'label') {
            head = t('w_halal_has');
            paras.push(esc(t('w_halal_has_t')));
        } else {
            head = t('w_halal_certify');
            cls = 'bad';
            paras.push('<b>' + esc(t('w_halal_not_nonhalal')) + '</b>');
            paras.push(esc(h.due === 'import' ? t('w_due_import')
                : t('w_due', { date: h.due === '2024-10-17' ? '17 Oktober 2024' : '17 Oktober 2026' })));
            paras.push(esc(t(h.path === 'self_declare' ? 'w_path_self' : 'w_path_reg')));
            paras.push(esc(t('w_sanction')));
        }
        return card(cls, t('w_halal'), head, paras, h.refs);
    }

    function ingCard(g) {
        if (g.verdict === 'forbidden') return card('warn', t('w_ing'), t('w_ing_forbidden'), [esc(t('w_ing_forbidden_t'))], g.refs);
        if (g.verdict === 'exempt') return card('info', t('w_ing'), t('w_ing_exempt'), [esc(t('w_ing_exempt_t'))], g.refs);
        return card('ok', t('w_ing'), t(g.source === 'lab' ? 'w_ing_lab' : 'w_ing_kepka'),
            [esc(t(g.source === 'lab' ? 'w_ing_lab_t' : 'w_ing_kepka_t')), esc(t('w_ing_when'))], g.refs);
    }

    function nutriCard(n) {
        if (n.verdict === 'none') return '';
        if (n.verdict === 'forbidden') return card('info', t('w_nutri'), t('w_nutri_forbidden'), [], n.refs);
        return card('info', t('w_nutri'), t('w_nutri_later'), [esc(t('w_nutri_t'))], n.refs);
    }

    function applyWizardToLabel() {
        var d = W.decide(wizardAnswers());
        var Lb = S.label;
        Lb.permit = d.permit.verdict;
        Lb.halal = d.halal.mark === 'label' ? 'sh' : (d.halal.mark === 'babi' ? 'babi' : (d.halal.mark === 'nonhalal' ? 'nonhalal' : 'none'));
        Lb.bpomShared = !!d.halal.bpomShared;
        if (S.wiz.origin === 'import') Lb.role = 'imported';
        S.ing.src = d.ing.source === 'lab' ? 'lab' : S.ing.src;
        Lb.ingOn = d.ing.verdict === 'required';
        syncLabelInputs();
        touch();
        ae('wizard_apply', { permit: d.permit.verdict, halal: Lb.halal });
        funnel('wizard_apply', { permit: d.permit.verdict, halal: Lb.halal, ing: d.ing.verdict });
        showTab('label', true);
    }

    /* ── ING tab ───────────────────────────────────────────────────────── */

    function currentItem() {
        if (S.ing.src === 'lab') {
            var v = S.ing.lab.map(num);
            if (v.some(function (x) { return x == null; })) return { name: t('lab_name'), v: null, lab: true };
            var s = num(S.ing.serving);
            return { name: t('lab_name'), v: v, lab: true, serving: s ? [s, s, S.ing.unit] : null };
        }
        return S.ing.kind ? byName(S.ing.kind) : null;
    }

    function computeIng() {
        var it = currentItem();
        if (!it) return null;
        var unit = it.serving && it.serving[2] === 'ml' ? 'ml' : (it.per100 === 'ml' ? 'ml' : S.ing.unit);
        var res = I.compute(it, {
            net: num(S.ing.net), serving: num(S.ing.serving), urt: S.ing.urt,
            spp: S.ing.spp, unit: unit,
        });
        res.urt = S.ing.urt;
        return res;
    }

    function renderKindCard() {
        var host = $('hl-kind-card');
        if (!host) return;
        var it = S.ing.src === 'kepka' && S.ing.kind ? byName(S.ing.kind) : null;
        var pop = $('hl-kind-pop');
        if (pop) { renderPopular(); pop.hidden = !!it || S.ing.src !== 'kepka'; }
        if (!it) { host.innerHTML = '<p class="tc-hint">' + esc(t('kind_none')) + '</p>'; return; }
        var h = '<p class="hl-kind-name">' + esc(it.name) + '</p>';
        if (it.desc) h += '<p class="hl-kind-desc">' + esc(it.desc) + '</p><p class="tc-hint">' + esc(t('kind_desc_check')) + '</p>';
        if (it.serving) h += '<p class="hl-kind-range">' + esc(t('kind_range', { min: fmt(it.serving[0]), max: fmt(it.serving[1]), unit: it.serving[2] === 'g|ml' ? 'g / ml' : it.serving[2] })) + '</p>';
        if (it.antara) h += '<p class="hl-kind-range">' + esc(t('kind_antara')) + '</p>';
        if (it.per100) h += '<p class="hl-kind-range">' + esc(t('kind_per100')) + '</p>';
        if (it.gap === 'no-values') h += '<p class="tc-msg warn">' + esc(t('kind_gap_values')) + '</p>';
        if (it.gap === 'no-serving') h += '<p class="tc-msg warn">' + esc(t('kind_gap_serving')) + '</p>';
        if (it.v) {
            h += '<details class="tc-drawer hl-per100"><summary>' + esc(t('kind_per100_caption')) + '</summary><div class="tc-drawer-body"><table class="tc-table"><tbody>';
            I.KEYS.forEach(function (k, i) {
                h += '<tr><th scope="row">' + esc(L.LABELS[k]) + '</th><td class="num">' + esc(fmt(it.v[i], 2)) + ' ' + esc(I.UNITS[k]) + '</td></tr>';
            });
            h += '</tbody></table></div></details>';
        }
        host.innerHTML = h;
    }

    /* Kopi bubuk, teh kering, rempah… are not in the act's table because the
       ING duty does not reach them (the wizard's «Jenis khusus»): a seller who
       looks for them is told so instead of «not found». */
    var EXEMPT_Q = /^(kopi|teh|rempah|bumbu|cuka|ragi|garam|merica|lada|ketumbar|kunyit|jahe)\b/;

    /* What most UMKM pouches are: one press instead of typing on a phone. */
    var POPULAR = ['Keripik Tempe', 'Keripik Singkong', 'Keripik Pisang Manis', 'Sambal Bawang', 'Abon Sapi',
        'Rempeyek Kacang Tanah', 'Nastar Nanas', 'Bakso Goreng'];
    function renderPopular() {
        var host = $('hl-kind-pop-list');
        if (!host || host.__built) return;
        host.innerHTML = POPULAR.filter(byName).map(function (n) {
            return '<button type="button" class="tc-chip" data-pop="' + esc(n) + '">' + esc(n) + '</button>';
        }).join('');
        host.__built = true;
    }

    var _kindDiag = {};
    function kindNotFoundDiag(q) {
        var f = I.find(ITEMS, q, 1);
        if (f.items.length && !f.partial) return;
        // the words of a food kind, never more than three of them — demand for kinds the act lacks
        var words = I.normalizeName(q).replace(/[0-9]+/g, ' ').split(' ').filter(Boolean).slice(0, 3).join(' ').slice(0, 32);
        if (!words || _kindDiag[words] || Object.keys(_kindDiag).length >= 5) return;
        _kindDiag[words] = 1;
        diag(f.items.length ? 'kind_near_only' : 'kind_not_found', { q: words, exempt: EXEMPT_Q.test(words) ? 1 : 0 });
    }

    function renderKindResults(q) {
        var list = $('hl-kind-res');
        if (!list) return;
        var fr = q ? I.find(ITEMS, q, 12) : { items: [], partial: false };
        var found = fr.items;
        if (!q) { list.hidden = true; list.innerHTML = ''; return; }
        var exempt = EXEMPT_Q.test(I.normalizeName(q)) && (fr.partial || !found.length)
            ? '<li role="presentation" class="hl-kind-empty hl-kind-note">' + esc(t('kind_exempt_hint')) + '</li>' : '';
        if (!found.length) {
            list.innerHTML = exempt + '<li role="presentation" class="hl-kind-empty">' + esc(t('kind_not_found')) + '</li>';
            list.hidden = false;
            return;
        }
        var head = fr.partial ? '<li role="presentation" class="hl-kind-empty hl-kind-note">' + esc(t('kind_partial')) + '</li>' : '';
        list.innerHTML = exempt + head + found.map(function (it, i) {
            var sub = it.serving ? fmt(it.serving[0]) + '–' + fmt(it.serving[1]) + ' ' + (it.serving[2] === 'g|ml' ? 'g/ml' : it.serving[2])
                : (it.antara ? t('kind_antara_short') : (it.per100 ? t('kind_per100_short') : ''));
            return '<li role="option" id="hl-kind-o' + i + '" data-name="' + esc(it.name) + '" aria-selected="false"><span>' + esc(it.name) + '</span><small>' + esc(sub) + '</small></li>';
        }).join('');
        list.hidden = false;
    }

    function pickKind(name) {
        S.ing.kind = name;
        S.ing.spp = null;
        var it = byName(name);
        var q = $('hl-kind');
        if (q) q.value = name;
        var list = $('hl-kind-res');
        if (list) list.hidden = true;
        if (it && it.serving) {
            var s = num(S.ing.serving);
            if (s == null || s < it.serving[0] || s > it.serving[1]) {
                S.ing.serving = String(Math.round((it.serving[0] + it.serving[1]) / 2 * 2) / 2).replace('.', ',');
                var si = $('hl-serving'); if (si) si.value = S.ing.serving;
            }
            if (it.serving[2] === 'ml') S.ing.unit = 'ml';
            if (it.serving[2] === 'g') S.ing.unit = 'g';
        }
        ae('ing_kind', { no: it ? it.no : null });
        funnel('ing_kind');
        touch();
        renderIng();
    }

    function ingSize(res, format) {
        // The ING preview is the table alone, on a "label" its own size.
        var wmm = format === 'tabular' ? 96 : (format === 'linear' ? 90 : 62);
        return wmm;
    }

    /* The table alone, on a "label" exactly its own size plus 1 mm: the
       vertical format takes its natural width, so the box is cropped to the
       ink rather than left at the width it was offered. */
    function ingItems(res, format, wmm) {
        var out = { items: [], ext: [] };
        var b = Math.max(1 / measure.oRatio({ font: 'noto', bold: false }) * 1.05, 2.0);
        L.ingBlock(res, { format: format, urt: S.ing.urt, color: PALETTE_TEXT }, 0, 0, wmm, b, 'noto', measure, out);
        var all = out.items.concat(out.ext);
        var x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
        all.forEach(function (it) {
            if (it.kind === 'text') return;   // text boxes carry slack; the frame bounds the table
            x0 = Math.min(x0, it.box.x); y0 = Math.min(y0, it.box.y);
            x1 = Math.max(x1, it.box.x + it.box.w); y1 = Math.max(y1, it.box.y + it.box.h);
        });
        var m = 1;
        all.forEach(function (it) { it.box.x += m - x0; it.box.y += m - y0; });
        return { items: out.items, ext: out.ext, w: Math.ceil((x1 - x0 + 2 * m) * 10) / 10, h: Math.ceil((y1 - y0 + 2 * m) * 10) / 10 };
    }

    function renderIng() {
        var src = S.ing.src;
        var root = $('hl-p-ing');
        if (!root) return;
        reflectChoices(root, { ingsrc: src, unit: S.ing.unit, fmt: S.ing.format });
        $('hl-kepka-wrap').hidden = src !== 'kepka';
        $('hl-lab-wrap').hidden = src !== 'lab';
        renderKindCard();
        var it = currentItem();
        // serving slider follows the act's range
        var rng = $('hl-serving-r');
        if (rng) {
            if (it && it.serving && !it.lab) {
                rng.min = it.serving[0]; rng.max = it.serving[1]; rng.step = 0.5; rng.disabled = false;
                var sv = num(S.ing.serving); if (sv != null) rng.value = sv;
            } else { rng.disabled = true; }
        }
        var unitSeg = $('hl-unit-seg');
        if (unitSeg) unitSeg.hidden = !(it && (it.lab || (it.serving && it.serving[2] === 'g|ml')));

        var res = computeIng();
        lastIng = res;
        var ans = $('hl-ing-ans'), sub = $('hl-ing-sub'), checks = $('hl-ing-checks');
        var prev = $('hl-ing-prev');
        var sppWrap = $('hl-spp-wrap');
        if (sppWrap) {
            if (res && res.sppInfo && res.sppInfo.tie) {
                sppWrap.hidden = false;
                sppWrap.innerHTML = '<span class="tc-f-l">' + esc(t('spp_tie', { raw: fmt(res.sppInfo.raw, 2) })) + '</span><div class="tc-seg" role="group">'
                    + res.sppInfo.options.map(function (o) {
                        var on = o === res.spp;
                        return '<button type="button" class="tc-seg-b' + (on ? ' on' : '') + '" data-spp="' + o + '" aria-pressed="' + on + '">' + esc(fmt(o)) + '</button>';
                    }).join('') + '</div>';
            } else { sppWrap.hidden = true; sppWrap.innerHTML = ''; }
        }
        if (!res) {
            ans.textContent = '—';
            sub.textContent = t(src === 'lab' ? 'ing_need_lab' : 'ing_need_kind');
            checks.innerHTML = '';
            prev.innerHTML = '';
            $('hl-ing-work').innerHTML = '';
            setIngButtons(false);
            return;
        }
        checks.innerHTML = res.checks.map(function (c) { return checkLi(c.level, ingCheckText(c)); }).join('');
        if (!res.rows.length) {
            ans.textContent = '—';
            sub.textContent = t('ing_no_table');
            prev.innerHTML = '';
            $('hl-ing-work').innerHTML = '';
            setIngButtons(false);
            return;
        }
        var e = res.byKey.energy;
        ans.textContent = fmt(e.value, 0) + ' kkal';
        sub.textContent = res.basis === 'serving' ? t('ing_ans_serving', { s: fmt(res.serving), u: res.unit })
            : (res.basis === 'pack' ? t('ing_ans_pack', { s: fmt(res.massG), u: res.unit }) : t('ing_ans_100', { u: res.unit }));
        var f = S.ing.format;
        var tb = ingItems(res, f, ingSize(res, f));
        drawPreview(prev, { w: tb.w, h: tb.h, items: tb.items, ext: tb.ext }, t('ing_prev_aria'));
        renderWork(res);
        setIngButtons(res.ok);
        if (res.ok) funnel('ing_ready', { src: S.ing.src, basis: res.basis });
        else res.checks.filter(function (c) { return c.level === 'error'; }).slice(0, 1).forEach(function (c) { diag('ing_' + c.code, { src: S.ing.src }); });
    }

    function setIngButtons(ok) {
        ['hl-ing-pdf', 'hl-ing-copy', 'hl-ing-tolabel'].forEach(function (id) {
            var b = $(id); if (b) b.disabled = !ok;
        });
    }

    function renderWork(res) {
        var host = $('hl-ing-work');
        if (!host) return;
        var mass = res.massG;
        var rows = res.rows.map(function (r) {
            var it = currentItem();
            var per100 = it.v[I.KEYS.indexOf(r.key)];
            var calc = fmt(mass) + ' / 100 × ' + fmt(per100, 2) + ' = ' + fmt(r.raw, 3);
            var akg = r.akg != null && res.basis !== '100'
                ? fmt(r.raw, 3) + ' / ' + I.ALG[r.key] + ' × 100 % = ' + fmt(r.akgRaw, 2) + ' % → <b>' + r.akg + ' %</b>' : '—';
            return '<tr><th scope="row">' + esc(L.LABELS[r.key]) + '</th><td class="num">' + esc(calc) + '</td><td class="num"><b>' + esc(fmt(r.value, r.decimals) + ' ' + r.unit) + '</b></td><td class="num">' + akg + '</td></tr>';
        });
        host.innerHTML = rows.join('');
    }

    function ingCheckText(c) {
        var v = {};
        for (var k in c) if (k !== 'code' && k !== 'level') v[k] = Array.isArray(c[k]) ? c[k].map(function (x) { return typeof x === 'number' ? fmt(x) : (L.LABELS[x] || x); }).join(', ') : (typeof c[k] === 'number' ? fmt(c[k]) : c[k]);
        if (c.code === 'over_100_alg' || c.code === 'sugar_over_50') {
            return t('chk_' + c.code, v) + ' ' + (c.maxServing != null ? t('chk_max_serving', { s: fmt(c.maxServing) }) : t('chk_no_serving_lab'));
        }
        return t('chk_' + c.code, v);
    }

    function checkLi(level, text) {
        var icon = level === 'error' ? '✗' : (level === 'warn' ? '!' : (level === 'ok' ? '✓' : 'i'));
        return '<li class="hl-chk hl-chk--' + level + '"><span class="hl-chk-i" aria-hidden="true">' + icon + '</span><span>' + text + '</span></li>';
    }

    /* ── preview ───────────────────────────────────────────────────────── */

    function drawPreview(host, lab, aria) {
        var fmtObj = { w: lab.w, h: lab.h, shape: 'rect', radius: 0 };
        var svg = window.LabelRender.renderLabel(host, fmtObj, { items: lab.items }, {
            fontFamilyFor: familyFor, barcodeUrl: barcodeUrl, paper: lab.paper || '#ffffff',
        });
        if (svg) {
            svg.setAttribute('role', 'img');
            svg.setAttribute('aria-label', aria || '');
            X.svg(svg, lab.ext || [], { fontFamilyFor: familyFor });
        }
        return svg;
    }

    var bcCache = {};
    function barcodeUrl(it) {
        var key = window.LabelRender.barcodeKey(it);
        if (bcCache[key] !== undefined) return bcCache[key];
        bcCache[key] = null;
        if (!window.bwipjs) { loadBwip().then(function () { delete bcCache[key]; renderActive(); }); return null; }
        try {
            var cv = document.createElement('canvas');
            window.bwipjs.toCanvas(cv, window.LabelRender.barcodeOptions(it, 4));
            bcCache[key] = cv.toDataURL('image/png');
        } catch (e) { bcCache[key] = null; }
        return bcCache[key];
    }
    var _bwipP = null;
    function loadBwip() {
        if (window.bwipjs) return Promise.resolve();
        if (_bwipP) return _bwipP;
        var urls = (C.assets && C.assets.bwip) || ['/vendor/bwip-js/bwip-js-min.js'];
        _bwipP = window.__assetChain && window.__assetChain.loadScript
            ? window.__assetChain.loadScript(urls, 'bwip-js')
            : new Promise(function (res, rej) { var s = document.createElement('script'); s.src = urls[0]; s.onload = res; s.onerror = rej; document.head.appendChild(s); });
        return _bwipP.catch(function () {});
    }

    function renderActive() {
        if (S.tab === 'ing') renderIng();
        else if (S.tab === 'label') renderLabel();
    }

    /* ── label tab ─────────────────────────────────────────────────────── */

    /* Die-cut sticker sheets of the label-maker registry whose cell is a
       usable packaging label (rectangles from 40 × 25 mm). Choosing one sets
       the label to the cell's size and prints on that exact grid. */
    function stickerSheets() {
        var S2 = window.LabelSheets;
        return S2.all().filter(function (f) {
            return f.shape === 'rect' && f.w >= 40 && f.h >= 25 && f.w <= 150 && f.cols * f.rows >= 2;
        });
    }
    function currentSheet() {
        var Lb = S.label;
        if (!Lb.sheet) return null;
        var f = window.LabelSheets.byId(Lb.sheet);
        if (!f || Math.abs(f.w - Lb.w) > 0.6 || Math.abs(f.h - Lb.h) > 0.6) return null;
        return f;
    }
    function fillSheetSelect() {
        var sel = $('hl-sheet');
        if (!sel || sel.__filled) return;
        stickerSheets().forEach(function (f) {
            var o = document.createElement('option');
            o.value = f.id;
            // not the registry id: «card-90x50» / «mk-58x40» are names for code, not for a seller
            o.textContent = t('sheet_opt', { name: sheetName(f), w: fmt(f.w), h: fmt(f.h), n: f.cols * f.rows, page: String(f.page).toUpperCase() });
            sel.appendChild(o);
        });
        sel.__filled = true;
    }

    function labelMode() {
        var Lb = S.label;
        if (Lb.mode !== 'auto') return Lb.mode;
        return Lb.w >= Lb.h * 1.15 ? 'cols' : 'single';
    }

    function permitDisplay() {
        var Lb = S.label;
        if (Lb.permit === 'pirt') { var p = R.pirt(Lb.permitNo); return p.display || (Lb.permitNo ? 'P-IRT No. ' + Lb.permitNo : 'P-IRT No. …'); }
        if (Lb.permit === 'md' || Lb.permit === 'ml') { var b = R.bpom(Lb.permitNo, Lb.permit); return b.digits ? b.display : 'BPOM RI ' + Lb.permit.toUpperCase() + ' …'; }
        return '';
    }

    function expiryInfo() {
        var Lb = S.label;
        var shelf = num(Lb.shelf);
        var rule = R.expiryRule(shelf);
        var form = Lb.expForm === 'auto' || !rule.forms || rule.forms.indexOf(Lb.expForm) < 0 ? (rule.dflt || 'dmy') : Lb.expForm;
        var prod = Lb.prodDate ? new Date(Lb.prodDate + 'T00:00:00') : null;
        var date = prod && shelf ? R.addDays(prod, shelf) : null;
        return { rule: rule, form: form, date: date, text: date ? R.expiryText(date, form, Lb.expStyle === 'words' ? 'words' : '') : '' };
    }

    function ingForLabel() {
        var res = computeIng();
        return res && res.ok && res.rows.length ? res : null;
    }

    function qrAllowed() {
        var Lb = S.label;
        var area = Lb.w * Lb.h / 100;
        return (area <= 30 && (Lb.qrCurah || Lb.qrSecondary)) || Lb.qrBottle;
    }

    function labelBlocks() {
        var Lb = S.label;
        var B = [];
        var main = function (b) { b.panel = 'main'; B.push(b); };
        var info = function (b) { b.panel = 'info'; B.push(b); };

        if (Lb.brand) main({ id: 'brand', type: 'para', role: 'brand', align: 'center', runs: [{ t: Lb.brand, b: true }] });
        main({ id: 'name', type: 'para', role: 'title', align: 'center', runs: [{ t: Lb.name || t('ph_name_label'), b: true }] });

        // keterangan tidak halal: the most visible place (Pasal 23 Peraturan BPJPH 3/2026)
        if (Lb.halal === 'babi' || Lb.halal === 'nonhalal') {
            var mk = Lb.halal === 'babi' ? MARKS.mengandung_babi : MARKS.non_halal;
            var colors = markColors(Lb.markVariant);
            main({ id: 'mark', type: 'mark', d: mk.d, vw: mk.w, vh: mk.h, fill: colors.fill, bg: colors.bg,
                heightMm: Math.max(3, num(Lb.markH) || 7), align: 'center', capRatio: mk.cap_ratio,
                capMin: Lb.halal === 'babi' ? 2 : 0 });
        }

        var netTxt = R.netText(num(Lb.netValue), Lb.netUnit);
        var right = [];
        if (netTxt) right.push({ id: 'net', type: 'para', runs: [{ t: netTxt, b: true }] });
        var pd = permitDisplay();
        if (pd) right.push({ id: 'permit', type: 'para', runs: [{ t: pd, b: true }] });
        if (Lb.halal === 'sh' && logo && logo.src && (Lb.shNo || '').trim()) {
            main({ id: 'halalrow', type: 'row', left: {
                id: 'halal', type: 'halal', src: logo.src, ratio: logo.ratio, number: R.shNumber(Lb.shNo).value,
                color: logoInk(), heightMm: Math.max(6, num(Lb.halalH) || 13), numberOutside: !!Lb.numberOutside,
            }, right: right });
        } else {
            right.forEach(main);
        }

        var who = Lb.role === 'imported' ? 'Diimpor oleh' : (Lb.role === 'for' ? 'Diproduksi untuk' : 'Diproduksi oleh');
        var org = [Lb.producer, Lb.address].filter(function (x) { return (x || '').trim(); }).join(', ');
        if (org) main({ id: 'producer', type: 'para', runs: [{ t: who + ': ', b: false }, { t: org, b: false }] });
        if (Lb.role === 'imported' && (Lb.importer || Lb.importerAddr)) {
            main({ id: 'maker', type: 'para', runs: [{ t: 'Diproduksi oleh: ' + [Lb.importer, Lb.importerAddr].filter(Boolean).join(', '), b: false }] });
        }

        var ex = expiryInfo();
        if (!ex.rule.exempt) {
            var exTxt = Lb.expMode === 'see' ? 'Baik digunakan sebelum, lihat ' + (Lb.expSee || 'kemasan')
                : 'Baik digunakan sebelum: ' + (ex.text || '…');
            main({ id: 'expiry', type: 'para', runs: [{ t: exTxt, b: false }] });
        }

        // ── information panel
        if ((Lb.ingredients || '').trim()) {
            var txt = Lb.ingredients.trim();
            var head = /^(komposisi|bahan|daftar bahan|bahan-bahan|bahan yang digunakan)\s*:/i.test(txt) ? '' : 'Komposisi: ';
            var al = R.allergens(txt);
            var runs = [];
            if (head) runs.push({ t: head, b: false });
            runs = runs.concat(R.ingredientRuns(txt, al, Lb.alOff));
            info({ id: 'ingredients', type: 'para', runs: runs });
            var groups = al.groups.filter(function (g) { return Lb.alOff.indexOf(g) < 0; });
            var st = R.allergenStatement(groups, Lb.alForm);
            if (st) info({ id: 'allergen', type: 'para', role: 'prominent', runs: st });
        }
        if (Lb.cross && Lb.cross.length) info({ id: 'cross', type: 'para', role: 'prominent', runs: R.crossContact(Lb.cross, Lb.crossForm) });
        if (Lb.sweet) info({ id: 'sweet', type: 'para', role: 'prominent', runs: [{ t: 'Mengandung pemanis buatan, disarankan tidak dikonsumsi oleh anak di bawah 5 (lima) tahun, ibu hamil, dan ibu menyusui.', b: false }] });
        if (Lb.aspartame) info({ id: 'aspartame', type: 'para', role: 'prominent', runs: [{ t: 'Mengandung fenilalanin, tidak cocok untuk penderita fenilketonurik.', b: false }] });
        if (Lb.polyol) info({ id: 'polyol', type: 'para', role: 'prominent', runs: [{ t: 'Konsumsi berlebihan mempunyai efek laksatif.', b: false }] });
        if (Lb.bpomShared) {
            info({ id: 'bpomshared', type: 'notice', color: RED, bg: '#ffffff', pig: MARKS.pig ? { d: MARKS.pig.d, vw: MARKS.pig.w, vh: MARKS.pig.h } : null,
                runs: [{ t: 'Pada proses pembuatannya bersinggungan dan/atau menggunakan fasilitas bersama dengan bahan bersumber babi', b: false }] });
        }
        if ((Lb.storage || '').trim()) info({ id: 'storage', type: 'para', runs: [{ t: Lb.storage.trim(), b: false }] });
        var codeTxt = Lb.codeMode === 'see' ? 'Kode produksi, lihat ' + (Lb.expSee || 'kemasan') : (Lb.code ? 'Kode produksi: ' + Lb.code : '');
        if (codeTxt) info({ id: 'code', type: 'para', runs: [{ t: codeTxt, b: false }] });

        if (Lb.ingOn) {
            var res = ingForLabel();
            if (res) {
                var f = Lb.ingFormat === 'auto' ? autoIngFormat() : Lb.ingFormat;
                if (f === 'qr') {
                    info({ id: 'ingqr', type: 'qr', value: L.ingText(res, S.ing.urt), sizeMm: Math.min(22, Math.max(12, Math.min(Lb.w, Lb.h) * 0.35)),
                        caption: [{ t: 'Informasi Nilai Gizi: pindai kode', b: false }] });
                } else {
                    info({ id: 'ing', type: 'ing', res: res, format: f, urt: S.ing.urt });
                }
            }
        }
        if ((Lb.ean || '').replace(/\D/g, '').length === 13) info({ id: 'ean', type: 'ean', value: Lb.ean.replace(/\D/g, ''), widthMm: 31, heightMm: 20 });
        if ((Lb.extra || '').trim()) info({ id: 'extra', type: 'para', runs: [{ t: Lb.extra.trim(), b: false }] });
        return B;
    }

    function autoIngFormat() {
        var Lb = S.label;
        var mode = labelMode();
        var colW = mode === 'cols' ? Lb.w / 2 : Lb.w;
        if (colW >= 90 && Lb.h < 60) return 'tabular';
        if (colW < 38) return 'linear';
        return 'vertical';
    }

    function markColors(v) {
        if (v === 'black') return { fill: '#000000', bg: '#ffffff' };
        if (v === 'white') return { fill: '#ffffff', bg: '#000000' };
        return { fill: RED, bg: '#ffffff' };
    }

    function logoInk() {
        var c = S.label.logoColor;
        if (c === 'hitam') return '#000000';
        if (c === 'putih') return '#ffffff';
        return logo && logo.an && logo.an.ink ? 'rgb(' + logo.an.ink.r + ',' + logo.an.ink.g + ',' + logo.an.ink.b + ')' : '#670075';
    }

    function doLayout() {
        var Lb = S.label;
        var mode = labelMode();
        var spec = { w: Lb.w, h: Lb.h, mode: mode, pad: Math.max(1.2, Math.min(3, Math.min(Lb.w, Lb.h) * 0.035)),
            font: 'noto', color: PALETTE_TEXT, blocks: labelBlocks() };
        var out = L.layout(spec, measure);
        out.spec = spec;
        return out;
    }

    function panelsOf(out) {
        var Lb = S.label;
        if (out.mode === 'cols') return [{ id: 'main', w: Lb.w, h: Lb.h, items: out.label.items, ext: out.label.ext }];
        if (out.mode === 'front_back') return [
            { id: 'main', w: Lb.w, h: Lb.h, items: out.panels.main.items, ext: out.panels.main.ext },
            { id: 'info', w: Lb.w, h: Lb.h, items: out.panels.info.items, ext: out.panels.info.ext },
        ];
        return [{ id: 'main', w: Lb.w, h: Lb.h, items: out.panels.main.items, ext: out.panels.main.ext }];
    }

    function renderLabel() {
        if (!measure) return;
        var root = $('hl-p-label');
        if (!root) return;
        var Lb = S.label;
        reflectChoices(root, {
            preset: Lb.preset, lmode: Lb.mode, print: Lb.print, permit: Lb.permit, halal: Lb.halal, logoColor: Lb.logoColor,
            markVariant: Lb.markVariant, alForm: Lb.alForm, crossForm: Lb.crossForm, expMode: Lb.expMode, expStyle: Lb.expStyle,
            codeMode: Lb.codeMode, ingFormat: Lb.ingFormat, netUnit: Lb.netUnit, role: Lb.role,
        });
        var show = function (id, on) { var el = $(id); if (el) el.hidden = !on; };
        show('hl-custom-size', Lb.preset === 'custom');
        show('hl-permit-no', Lb.permit !== 'none');
        show('hl-sh-box', Lb.halal === 'sh');
        show('hl-mark-box', Lb.halal === 'babi' || Lb.halal === 'nonhalal');
        show('hl-nosh-box', Lb.halal === 'none');
        show('hl-importer-box', Lb.role === 'imported');
        show('hl-exp-date-box', Lb.expMode === 'date');
        show('hl-exp-see-box', Lb.expMode === 'see' || Lb.codeMode === 'see');
        show('hl-code-box', Lb.codeMode === 'text');
        show('hl-cut-row', Lb.print === 'a4' || Lb.print === 'f4');
        fillSheetSelect();
        var sheet = currentSheet();
        var selS = $('hl-sheet');
        if (selS && document.activeElement !== selS) selS.value = sheet ? sheet.id : '';
        var sheetBtn = root.querySelector('[data-q="print"][data-v="sheet"]');
        if (sheetBtn) sheetBtn.disabled = !sheet;
        if (Lb.print === 'sheet' && !sheet) Lb.print = 'page';
        var qrBtn = root.querySelector('[data-q="ingFormat"][data-v="qr"]');
        if (qrBtn) qrBtn.disabled = !qrAllowed();
        if (Lb.ingFormat === 'qr' && !qrAllowed()) Lb.ingFormat = 'auto';

        renderAllergenChips();
        renderPermitMsg();
        renderExpiryMsg();

        var out = doLayout();
        lastLayout = out;
        var host = $('hl-prev');
        host.innerHTML = '';
        panelsOf(out).forEach(function (p) {
            var fig = document.createElement('figure');
            fig.className = 'hl-prev-fig';
            var box = document.createElement('div');
            box.className = 'hl-prev-svg';
            fig.appendChild(box);
            if (out.mode === 'front_back') {
                var cap = document.createElement('figcaption');
                cap.textContent = t(p.id === 'main' ? 'prev_front' : 'prev_back');
                fig.appendChild(cap);
            }
            host.appendChild(fig);
            drawPreview(box, p, t('prev_aria'));
        });
        renderFit(out);
        renderChecks(out);
        // the sheet copies the preview: after it, and off the typing path
        clearTimeout(sheetTmr);
        sheetTmr = setTimeout(function () { renderSheetPreview(out); }, 180);
        // a picture or a PDF made from an older label is not offered as this one
        var key = labelKey();
        if (shot && shot.key !== key && $('hl-shot')) $('hl-shot').hidden = true;
        if (lastPdf && (lastPdf.key !== key || lastPdf.print !== printSig())) lastPdf = null;
        renderShareRow();
        /* The daily counter speaks about THIS label: «repeat free» when it was
           exported today, and a wall raised by another label comes down when
           the person goes back to one already counted (QA 23.10.2026: after
           label C hit the cap, label A stayed behind a dimmed button). */
        var TL = window.__toolLimit;
        if (TL && TL.freshKeys) {
            try {
                if (TL.pending) TL.pending(SLUG, [key]);
                if (!TL.freshKeys(SLUG, [key]).length && TL.clearNote) TL.clearNote(SLUG);
            } catch (_) {}
        }
    }
    var sheetTmr = null;

    function renderFit(out) {
        var ans = $('hl-fit-v'), sub = $('hl-fit-sub');
        if (!ans) return;
        var b = out.b, o = b * out.oRatio;
        if (!out.fits) {
            var over = Math.max.apply(null, Object.keys(out.over).map(function (k) { return out.over[k]; }));
            ans.textContent = t('fit_no');
            sub.textContent = t('fit_no_t', { mm: fmt(Math.ceil(over * 10) / 10, 1) });
            return;
        }
        ans.textContent = t('fit_yes', { pt: fmt(b / 25.4 * 72, 1), mm: fmt(Math.round(o * 100) / 100, 2) });
        sub.textContent = t('fit_yes_t', { min: fmt(out.oMin.body, 2), area: fmt(Math.round(out.areaCm2 * 10) / 10, 1) });
    }

    /* Everything the label must say, checked against what it says. */
    function labelChecks(out) {
        var Lb = S.label, c = [];
        // the rule's code rides along for telemetry: which rule failed, never what was typed
        var lastKey = '';
        var tc = function (k, v) { lastKey = k; return t(k, v); };
        var push = function (level, text) { c.push({ level: level, text: text, code: lastKey.replace(/^chk_/, '') }); };
        if (!out.fits) push('error', tc('chk_fit'));
        var small = out.audit.filter(function (a) { return !a.ok; });
        small.forEach(function (a) {
            if (a.kind === 'mark') push('error', tc('chk_mark_cap', { cap: fmt(a.cap, 1), min: fmt(a.capMin, 0) }));
            else push('error', tc('chk_small', { id: tc('fld_' + a.id), o: fmt(a.o, 2), min: fmt(a.oMin, 2) }));
        });
        if (!(Lb.name || '').trim()) push('error', tc('chk_name'));
        if (!(num(Lb.netValue) > 0)) push('error', tc('chk_net'));
        if (!(Lb.producer || '').trim() || !(Lb.address || '').trim()) push('error', tc('chk_producer'));
        else if (Lb.role !== 'imported' && !(/\b\d{5}\b/.test(Lb.address) && /indonesia/i.test(Lb.address))) push('warn', tc('chk_address'));
        if (Lb.role === 'imported' && !(Lb.importer || '').trim()) push('warn', tc('chk_maker_abroad'));
        if (!(Lb.ingredients || '').trim()) push('error', tc('chk_ingredients'));

        // permit
        if (Lb.permit === 'pirt') {
            var p = R.pirt(Lb.permitNo);
            p.findings.forEach(function (f) { push(f.level, tc('chk_' + f.code, { n: f.n, year: f.year, code: f.code2 })); });
            if (p.ok && p.province) push('ok', tc('chk_pirt_ok', { prov: p.province, year: p.parts.expYear }));
        } else if (Lb.permit === 'md' || Lb.permit === 'ml') {
            R.bpom(Lb.permitNo, Lb.permit).findings.forEach(function (f) { push(f.level, tc('chk_' + f.code, { n: f.n, found: f.found, want: f.want })); });
        }
        var wiz = W.decide(wizardAnswers());
        if (Lb.permit === 'none' && wiz.permit.verdict !== 'none') push('warn', tc('chk_permit_missing'));

        // halal
        var hints = R.halalHints(Lb.ingredients);
        var porkOrAlcohol = hints.filter(function (h) { return h.code === 'ing_pork' || h.code === 'ing_alcohol'; });
        if (Lb.halal === 'sh') {
            var sh = R.shNumber(Lb.shNo);
            sh.findings.forEach(function (f) { push(f.level, tc('chk_' + f.code)); });
            if (!logo) push('error', tc('chk_logo_missing'));
            else {
                var v = LG.inkVerdict(logo.an);
                if (v === 'green') push('error', tc('chk_logo_green'));
                else if (v === 'other' && Lb.logoColor === 'asli') push('warn', tc('chk_logo_color'));
            }
            porkOrAlcohol.forEach(function (h) { push('error', tc('chk_halal_conflict', { term: h.term })); });
        } else if (Lb.halal === 'none') {
            if (wiz.halal.verdict === 'certify') push('warn', tc('chk_no_sh'));
            porkOrAlcohol.forEach(function (h) { push('warn', tc('chk_' + h.code, { term: h.term })); });
        }
        hints.filter(function (h) { return h.code === 'ing_origin'; }).forEach(function (h) { push('warn', tc('chk_ing_origin', { term: h.term })); });

        // allergens
        var al = R.allergens(Lb.ingredients);
        al.matches.filter(function (m) { return m.ambiguous; }).forEach(function (m) { push('warn', tc('chk_kacang', { term: m.term })); });
        if (al.groups.indexOf('sulphite') >= 0 && Lb.alOff.indexOf('sulphite') < 0) push('info', tc('chk_sulphite'));

        // dates
        var ex = expiryInfo();
        if (!ex.rule.exempt && Lb.expMode === 'date') {
            if (!ex.date) push('error', tc('chk_expiry'));
            else if (Lb.expForm === 'my' && ex.rule.forms && ex.rule.forms.indexOf('my') < 0) push('error', tc('chk_expiry_form'));
        }
        if (Lb.codeMode === 'text' && !(Lb.code || '').trim()) push('warn', tc('chk_code'));

        // ING
        if (Lb.ingOn) {
            var res = computeIng();
            if (!res || !res.ok || !res.rows.length) push('error', tc('chk_ing_missing'));
            else if (num(S.ing.net) !== num(Lb.netValue) && num(Lb.netValue) > 0) push('warn', tc('chk_ing_net', { a: fmt(num(S.ing.net) || 0), b: fmt(num(Lb.netValue)) }));
        } else if (wiz.ing.verdict === 'required') push('warn', tc('chk_ing_off'));
        var ean = (Lb.ean || '').replace(/\D/g, '');
        if (ean && !eanValid(ean)) push('error', tc('chk_ean'));
        if (!c.some(function (x) { return x.level === 'error'; })) push('ok', tc('chk_all_ok'));
        return c;
    }

    function eanValid(d) {
        if (!/^\d{13}$/.test(d)) return false;
        var s = 0;
        for (var i = 0; i < 12; i++) s += (+d[i]) * (i % 2 ? 3 : 1);
        return (10 - s % 10) % 10 === +d[12];
    }

    function renderChecks(out) {
        var host = $('hl-checks');
        if (!host) return;
        var list = labelChecks(out);
        var order = { error: 0, warn: 1, info: 2, ok: 3 };
        list.sort(function (a, b) { return order[a.level] - order[b.level]; });
        host.innerHTML = list.map(function (c) { return checkLi(c.level, esc(c.text)); }).join('');
        var errors = list.filter(function (x) { return x.level === 'error'; }).length;
        lastChecks = list;
        if (started && out.fits && !errors) funnel('label_valid', { w: S.label.w, h: S.label.h, mode: out.mode });
        var sum = $('hl-checks-sum');
        if (sum) {
            sum.textContent = errors ? t('chk_sum_err', { n: errors }) : t('chk_sum_ok');
            sum.className = 'hl-chk-sum ' + (errors ? 'bad' : 'ok');
        }
        var btn = $('hl-export-pdf');
        if (btn) {
            btn.disabled = !out.fits;
            btn.title = out.fits ? '' : t('fit_no');
        }
        var note = $('hl-export-note');
        if (note) note.textContent = !out.fits ? t('export_blocked') : (errors ? t('export_with_errors') : '');
    }

    function renderAllergenChips() {
        var host = $('hl-al-chips');
        if (!host) return;
        var Lb = S.label;
        var al = R.allergens(Lb.ingredients);
        if (!al.groups.length) { host.innerHTML = '<span class="tc-hint">' + esc(t('al_none')) + '</span>'; return; }
        host.innerHTML = al.groups.map(function (g) {
            var on = Lb.alOff.indexOf(g) < 0;
            return '<button type="button" class="tc-chip' + (on ? ' on' : '') + '" data-al="' + g + '" aria-pressed="' + on + '">' + esc(t('al_' + g)) + '</button>';
        }).join('');
        var cross = $('hl-cross-chips');
        if (cross && !cross.__built) {
            cross.innerHTML = R.GROUPS.map(function (g) {
                return '<button type="button" class="tc-chip" data-cross="' + g + '" aria-pressed="false">' + esc(t('al_' + g)) + '</button>';
            }).join('');
            cross.__built = true;
        }
        if (cross) cross.querySelectorAll('[data-cross]').forEach(function (b) {
            var on = Lb.cross.indexOf(b.getAttribute('data-cross')) >= 0;
            b.classList.toggle('on', on); b.setAttribute('aria-pressed', on);
        });
    }

    function renderPermitMsg() {
        var host = $('hl-permit-msg');
        if (!host) return;
        var Lb = S.label;
        if (Lb.permit === 'none' || !(Lb.permitNo || '').trim()) { host.textContent = ''; host.className = 'tc-hint'; return; }
        var r = Lb.permit === 'pirt' ? R.pirt(Lb.permitNo) : R.bpom(Lb.permitNo, Lb.permit);
        var f = r.findings[0];
        host.className = 'tc-hint ' + (f ? (f.level === 'error' ? 'hl-bad' : 'hl-warn') : 'hl-good');
        host.textContent = f ? t('chk_' + f.code, { n: f.n, year: f.year, code: f.code2, found: f.found, want: f.want })
            : (Lb.permit === 'pirt' ? t('chk_pirt_ok', { prov: r.province || '?', year: r.parts.expYear }) + ' → ' + r.display : r.display);
    }

    function renderExpiryMsg() {
        var host = $('hl-exp-msg');
        if (!host) return;
        var ex = expiryInfo();
        if (ex.rule.need === 'shelf') { host.textContent = t('exp_need_shelf'); return; }
        host.textContent = (ex.text ? t('exp_will_print', { d: ex.text }) + ' ' : '')
            + t(ex.rule.forms && ex.rule.forms.length > 1 ? 'exp_rule_long' : 'exp_rule_short');
        var myBtn = $('hl-p-label').querySelector('[data-q="expForm"][data-v="my"]');
        if (myBtn) myBtn.disabled = !(ex.rule.forms && ex.rule.forms.indexOf('my') >= 0);
    }

    function syncLabelInputs() {
        var Lb = S.label;
        document.querySelectorAll('#hl-p-label [data-f]').forEach(function (el) {
            var k = el.getAttribute('data-f');
            if (!(k in Lb)) return;
            if (el.type === 'checkbox') el.checked = !!Lb[k];
            else if (document.activeElement !== el) el.value = Lb[k] == null ? '' : Lb[k];
        });
        document.querySelectorAll('#hl-p-ing [data-g]').forEach(function (el) {
            var k = el.getAttribute('data-g');
            if (document.activeElement === el) return;
            if (k.indexOf('lab') === 0) el.value = S.ing.lab[+k.slice(3)] || '';
            else el.value = S.ing[k] == null ? '' : S.ing[k];
        });
        var kq = $('hl-kind'); if (kq && document.activeElement !== kq) kq.value = S.ing.kind || '';
    }

    /* ── halal logo file ───────────────────────────────────────────────── */

    function loadLogo(file) {
        if (!file) return;
        if (!/^image\//.test(file.type) && !/\.(png|jpe?g|webp|svg)$/i.test(file.name || '')) {
            window.__toast && window.__toast(t('logo_bad_type'), 'error');
            return;
        }
        decodeImage(file).then(function (bm) {
            var maxSide = 1400;
            var sc = Math.min(1, maxSide / Math.max(bm.width, bm.height));
            var w = Math.max(1, Math.round(bm.width * sc)), h = Math.max(1, Math.round(bm.height * sc));
            var cv = document.createElement('canvas'); cv.width = w; cv.height = h;
            var g = cv.getContext('2d', { willReadFrequently: true });
            g.drawImage(bm, 0, 0, w, h);
            var data = g.getImageData(0, 0, w, h).data;
            var an = LG.analyze(data, w, h);
            if (!an.bbox) throw new Error('empty');
            logo = { blob: file, an: an, w: w, h: h, data: data };
            repaintLogo();
            ae('logo', { v: LG.inkVerdict(an) });
            if (LG.inkVerdict(an) === 'green') diag('logo_green_mui');
            touch();
            renderLabel();
        }).catch(function (e) {
            /* The previous file must not stay on the label while the state says
               «no logo» (QA 23.10.2026: a broken file left the old green
               verdict on screen and the old logo in the preview). */
            logo = null;
            var msg = $('hl-logo-msg');
            if (msg) { msg.textContent = t('logo_bad'); msg.className = 'tc-hint hl-bad'; }
            diag('logo_unreadable', { type: String(file.type || '').slice(0, 24) });
            touch();
            renderLabel();
            if (window.__handleError) window.__handleError(e, 'halal_logo_decode', { say: t('logo_bad') });
            else if (window.__toast) window.__toast(t('logo_bad'), 'error');
        });
    }

    function decodeImage(file) {
        if (window.createImageBitmap && !/svg/i.test(file.type)) return createImageBitmap(file);
        return new Promise(function (res, rej) {
            var url = URL.createObjectURL(file);
            var img = new Image();
            img.onload = function () { URL.revokeObjectURL(url); res(img); };
            img.onerror = function () { URL.revokeObjectURL(url); rej(new Error('image decode')); };
            img.src = url;
        });
    }

    function repaintLogo() {
        if (!logo) return;
        var hex = LG.PALETTE[S.label.logoColor];
        var r = LG.recolor(logo.an, logo.w, hex === undefined ? null : hex, 2, logo.data);
        var cv = document.createElement('canvas'); cv.width = r.w; cv.height = r.h;
        cv.getContext('2d').putImageData(new ImageData(r.data, r.w, r.h), 0, 0);
        logo.src = cv.toDataURL('image/png');
        logo.ratio = r.w / r.h;
        var v = LG.inkVerdict(logo.an);
        var msg = $('hl-logo-msg');
        if (msg) {
            msg.textContent = t('logo_v_' + v);
            msg.className = 'tc-hint ' + (v === 'green' ? 'hl-bad' : (v === 'other' ? 'hl-warn' : 'hl-good'));
        }
    }

    /* ── export ────────────────────────────────────────────────────────── */

    function hashKey(str) {
        // FNV-1a 32-bit, twice with different seeds: a stable key for "this
        // exact label" (re-export of the same content the same day is free).
        var h1 = 0x811c9dc5, h2 = 0x01000193 ^ 0x5bd1e995;
        for (var i = 0; i < str.length; i++) {
            var c = str.charCodeAt(i);
            h1 ^= c; h1 = Math.imul(h1, 0x01000193);
            h2 ^= c; h2 = Math.imul(h2, 0x5bd1e995); h2 ^= h2 >>> 15;
        }
        return 'hl:' + (h1 >>> 0).toString(36) + (h2 >>> 0).toString(36);
    }

    function pdfFormat(w, h) {
        // one label per page: the page box IS the label (the engine's roll shape)
        return { id: 'hl-page', family: 'roll', page: { w: w, h: h }, cols: 1, rows: 1, w: w, h: h,
            x0: 0, y0: 0, dx: w, dy: h, shape: 'rect', radius: 0, src: 'custom', confirmedBy: null };
    }

    function gridFormat(pageId, w, h) { return L.gridFormat(window.LabelSheets, pageId, w, h); }

    /* What the PDF is printed on, for the current choice: one label per page
       (the page IS the label — thermal printers), a repeating A4 / F4 sheet,
       or the die-cut sticker sheet whose cell is the label. */
    function printFormat() {
        var Lb = S.label;
        if (Lb.print === 'sheet' && currentSheet()) return { fmt: currentSheet(), sheet: true };
        if (Lb.print === 'a4' || Lb.print === 'f4') return { fmt: gridFormat(Lb.print, Lb.w, Lb.h), sheet: true };
        return { fmt: pdfFormat(Lb.w, Lb.h), sheet: false };
    }

    /* «The same label» for the daily count: what is ON the label and its size.
       How it is printed (one per page, A4, F4, a sticker sheet, cut marks) and
       how the blocks are arranged are not another label — the PDF for the shop
       and the picture for WhatsApp of one label are one unit (QA 23.10.2026:
       the page PDF and then the A4 sheet of the same label cost two). */
    var NOT_CONTENT = { print: 1, cut: 1, sheet: 1, preset: 1, mode: 1, batch: 1 };
    function labelKey() {
        var l = {};
        for (var k in S.label) if (Object.prototype.hasOwnProperty.call(S.label, k) && !NOT_CONTENT[k]) l[k] = S.label[k];
        var i = {};
        for (var g in S.ing) if (Object.prototype.hasOwnProperty.call(S.ing, g) && g !== 'format') i[g] = S.ing[g];
        return hashKey(JSON.stringify({ l: l, i: i, logo: logo && logo.src ? logo.src.length : 0 }));
    }

    function printSig() { var Lb = S.label; return [Lb.print, Lb.sheet, Lb.cut, Lb.mode].join(':'); }

    function begin() {
        return window.__toolLimit && window.__toolLimit.begin ? window.__toolLimit.begin(SLUG, [labelKey()]) : { commit: function () {}, abort: function () {} };
    }

    function errorCodes() {
        return lastChecks.filter(function (c) { return c.level === 'error'; }).map(function (c) { return c.code; }).slice(0, 8).join(',');
    }

    function exportLabel() {
        var out = lastLayout || doLayout();
        funnel('export_click');
        if (!out.fits) {
            diag('label_overflow', { w: S.label.w, h: S.label.h, mode: out.mode });
            window.__toast && window.__toast(t('export_blocked'), 'error');
            return;
        }
        var Lb = S.label;
        var panels = panelsOf(out);
        var run = begin();
        if (!run) { diag('export_capped', { print: Lb.print }); return; }
        var btn = $('hl-export-pdf');
        if (btn) btn.setAttribute('aria-busy', 'true');
        var pf = printFormat(), fmtObj = pf.fmt, cells = [];
        if (pf.sheet) {
            var per = window.LabelSheets.perSheet(fmtObj);
            panels.forEach(function (p) { for (var i = 0; i < per; i++) cells.push(p); });
        } else {
            cells = panels.slice();
        }
        window.__LABEL_MAKER__ = window.__LABEL_MAKER__ || { assets: C.assets || {} };
        var job = { fmt: fmtObj, cells: cells.map(function (p) { return { items: p.items }; }),
            cutMarks: (Lb.print === 'a4' || Lb.print === 'f4') && Lb.cut, ruler: pf.sheet, rulerCaption: '50 mm' };
        var name = '';
        window.LabelPdf.build(job).then(function (res) {
            return X.overlay(res.bytes, { fmt: fmtObj, cells: cells.map(function (p) { return { ext: p.ext }; }),
                title: 'Label ' + (Lb.name || ''), lang: 'id-ID' });
        }).then(function (bytes) {
            name = fileBase() + (Lb.print === 'a4' ? '-A4' : (Lb.print === 'f4' ? '-F4' : '')) + '.pdf';
            var blob = new Blob([bytes], { type: 'application/pdf' });
            lastPdf = { blob: blob, name: name, key: labelKey(), print: printSig() };
            return Promise.resolve(window.__downloadFile(blob, name));
        }).then(function (ok) {
            if (ok === false) { run.abort(); lastPdf = null; return; }
            run.commit();
            if (editor) try { editor.exported(); } catch (_) {}
            try {
                window.__aeToolComplete && window.__aeToolComplete({ kind: 'label', mode: out.mode, print: Lb.print, sheet: Lb.print === 'sheet' ? Lb.sheet : '',
                    w: Lb.w, h: Lb.h, halal: Lb.halal, permit: Lb.permit, ing: Lb.ingOn ? (Lb.ingFormat || 'auto') : 'off',
                    errors: lastChecks.filter(function (c) { return c.level === 'error'; }).length, codes: errorCodes() });
            } catch (_) {}
        }).catch(function (e) {
            run.abort();
            lastPdf = null;
            if (window.__handleError) window.__handleError(e, 'halal_label_pdf', { say: t('export_failed') });
        }).then(function () { if (btn) btn.removeAttribute('aria-busy'); renderShareRow(); });
    }

    function fileBase() {
        var base = 'label-' + ((S.label.name || '').trim() || 'kemasan');
        return window.__outputName && window.__outputName.sanitize ? window.__outputName.sanitize(base) : base.replace(/[\/:*?"<>|]+/g, ' ');
    }

    /* ── to a chat: the PDF for the print shop, a picture for buyers ─────
       An UMKM sends the label by WhatsApp — the PDF to the percetakan, a
       picture to a reseller or the marketplace listing. Sharing a file needs
       a fresh press (a share sheet opened after a long await is refused), so
       the file is made first and «Bagikan» is its own press. */
    function canShareType(type, name) {
        try {
            return !!(navigator.canShare && navigator.share && navigator.canShare({ files: [new File([new Blob(['x'], { type: type })], name, { type: type })] }));
        } catch (_) { return false; }
    }

    function renderShareRow() {
        var b = $('hl-share-pdf');
        if (b) b.hidden = !(lastPdf && canShareType('application/pdf', 'a.pdf'));
    }

    function shareFile(blob, name, what) {
        var file = new File([blob], name, { type: blob.type });
        return navigator.share({ files: [file], title: name }).then(function () {
            ae('share', { what: what });
            return true;
        }, function (e) {
            if (e && e.name === 'AbortError') { ae('share_cancel', { what: what }); return false; }
            ae('share_failed', { what: what, err: String((e && e.name) || 'x').slice(0, 30) });
            window.__toast && window.__toast(t('share_failed'), 'error');
            return false;
        });
    }

    function sharePdf() {
        if (!lastPdf) return;
        shareFile(lastPdf.blob, lastPdf.name, 'pdf');
    }

    /* The label as a picture: the preview SVG — the same item list the PDF
       draws, italic footnote and vector marks included — rasterised with the
       label's own font files embedded (an SVG drawn as an image sees no page
       fonts). ~12 px per mm ≈ 300 dpi, longest side ≤ 2400 px. */
    var _fontData = null;
    function fontData() {
        if (_fontData) return _fontData;
        var urls = (C.assets && C.assets.fonts) || [];
        _fontData = Promise.all(urls.map(function (u) {
            return fetch(u, { credentials: 'same-origin' }).then(function (r) {
                if (!r.ok) throw new Error('font ' + r.status);
                return r.blob();
            }).then(function (b) {
                return new Promise(function (res, rej) { var fr = new FileReader(); fr.onload = function () { res(fr.result); }; fr.onerror = rej; fr.readAsDataURL(b); });
            });
        })).catch(function (e) { _fontData = null; throw e; });
        return _fontData;
    }

    function svgToCanvas(svgs, pxPerMm) {
        return fontData().then(function (fonts) {
            var css = fonts.length ? '@font-face{font-family:"HL Noto Sans";font-weight:400;src:url(' + fonts[0] + ')}'
                + (fonts[1] ? '@font-face{font-family:"HL Noto Sans";font-weight:700;src:url(' + fonts[1] + ')}' : '') : '';
            var gapMm = svgs.length > 1 ? 6 : 0, marginMm = 3;
            var sizes = svgs.map(function (s) { var vb = s.viewBox.baseVal; return { w: vb.width, h: vb.height }; });
            var totW = sizes.reduce(function (a, s) { return a + s.w; }, 0) + gapMm * (svgs.length - 1) + 2 * marginMm;
            var totH = Math.max.apply(null, sizes.map(function (s) { return s.h; })) + 2 * marginMm;
            var k = Math.min(pxPerMm, 2400 / Math.max(totW, totH));
            var cv = document.createElement('canvas');
            cv.width = Math.round(totW * k); cv.height = Math.round(totH * k);
            var g = cv.getContext('2d');
            g.fillStyle = '#f3f4f6'; g.fillRect(0, 0, cv.width, cv.height);
            var x = marginMm;
            return svgs.reduce(function (p, s, i) {
                return p.then(function () {
                    var clone = s.cloneNode(true);
                    clone.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
                    clone.setAttribute('width', String(Math.round(sizes[i].w * k)));
                    clone.setAttribute('height', String(Math.round(sizes[i].h * k)));
                    clone.removeAttribute('style');
                    if (css) {
                        var st = document.createElementNS('http://www.w3.org/2000/svg', 'style');
                        st.textContent = css;
                        clone.insertBefore(st, clone.firstChild);
                    }
                    var src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(new XMLSerializer().serializeToString(clone));
                    return new Promise(function (res, rej) {
                        var img = new Image();
                        img.onload = function () { res(img); };
                        img.onerror = function () { rej(new Error('svg raster')); };
                        img.src = src;
                    }).then(function (img) {
                        var px = Math.round(x * k), py = Math.round(marginMm * k);
                        g.fillStyle = '#ffffff';
                        g.fillRect(px, py, Math.round(sizes[i].w * k), Math.round(sizes[i].h * k));
                        g.drawImage(img, px, py, Math.round(sizes[i].w * k), Math.round(sizes[i].h * k));
                        x += sizes[i].w + gapMm;
                    });
                });
            }, Promise.resolve()).then(function () { return cv; });
        });
    }

    function makeShot() {
        var out = lastLayout || doLayout();
        if (!out.fits) { diag('label_overflow', { w: S.label.w, h: S.label.h, mode: out.mode, via: 'image' }); window.__toast && window.__toast(t('export_blocked'), 'error'); return; }
        var svgs = Array.prototype.slice.call(document.querySelectorAll('#hl-prev .hl-prev-svg > svg'));
        if (!svgs.length) return;
        var btn = $('hl-img'), box = $('hl-shot');
        if (btn) btn.setAttribute('aria-busy', 'true');
        funnel('image_click');
        var key = labelKey();
        svgToCanvas(svgs, 12).then(function (cv) {
            if (!window.__canvasBlob) throw new Error('canvas door missing');
            return window.__canvasBlob(cv, 'image/png');
        }).then(function (blob) {
            if (!blob) throw new Error('png empty');
            if (shot && shot.url) URL.revokeObjectURL(shot.url);
            shot = { blob: blob, url: URL.createObjectURL(blob), key: key, name: fileBase() + '.png' };
            var img = $('hl-shot-img');
            if (img) img.src = shot.url;
            var sb = $('hl-shot-share');
            if (sb) sb.hidden = !canShareType('image/png', 'a.png');
            if (box) box.hidden = false;
            ae('image_ready', { kb: Math.round(blob.size / 1024) });
        }).catch(function (e) {
            if (window.__handleError) window.__handleError(e, 'halal_label_png', { say: t('img_failed') });
        }).then(function () { if (btn) btn.removeAttribute('aria-busy'); });
    }

    /* Delivering the picture is delivering the label: the same unit as its PDF
       (same key — a label already exported today is not counted twice). */
    function deliverShot(how) {
        if (!shot) return;
        if (shot.key !== labelKey()) { $('hl-shot').hidden = true; makeShot(); return; }
        var run = begin();
        if (!run) { diag('export_capped', { print: 'image' }); return; }
        var p = how === 'share' ? shareFile(shot.blob, shot.name, 'image')
            : Promise.resolve(window.__downloadFile(shot.blob, shot.name));
        p.then(function (ok) {
            if (ok === false) { run.abort(); return; }
            run.commit();
            try { window.__aeToolComplete && window.__aeToolComplete({ kind: 'image', via: how, w: S.label.w, h: S.label.h, halal: S.label.halal, errors: lastChecks.filter(function (c) { return c.level === 'error'; }).length }); } catch (_) {}
        }, function () { run.abort(); });
    }

    /* ── the print sheet, drawn ───────────────────────────────────────────
       What comes out of the printer when the label repeats on A4 / F4 or a
       sticker sheet: every cell the label itself (a copy of the live preview),
       the count on the sheet, the back page when there is one. The person sees
       «18 on F4» before buying paper, not after. */
    function renderSheetPreview(out) {
        var panel = $('hl-sheet-panel'), host = $('hl-sheet-prev'), cap = $('hl-sheet-cap');
        if (!panel || !host) return;
        var pf = printFormat();
        if (!pf.sheet) { panel.hidden = true; host.innerHTML = ''; return; }
        panel.hidden = false;
        var fmtObj = pf.fmt, per = window.LabelSheets.perSheet(fmtObj);
        var svg = window.LabelRender.renderSheet(host, fmtObj, null, { ariaLabel: t('sheet_prev_aria'), ruler: true, paper: '#ffffff' });
        var label = document.querySelector('#hl-prev .hl-prev-svg > svg');
        if (svg && label) {
            svg.querySelectorAll('.lm-cell').forEach(function (c) { c.parentNode.removeChild(c); });
            for (var i = 0; i < per; i++) {
                var cell = window.LabelSheets.cellAt(fmtObj, i, {});
                var n = label.cloneNode(true);
                n.removeAttribute('style'); n.removeAttribute('role'); n.removeAttribute('aria-label');
                n.setAttribute('x', cell.x); n.setAttribute('y', cell.y);
                n.setAttribute('width', cell.w); n.setAttribute('height', cell.h);
                svg.appendChild(n);
                var edge = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
                edge.setAttribute('x', cell.x); edge.setAttribute('y', cell.y);
                edge.setAttribute('width', cell.w); edge.setAttribute('height', cell.h);
                edge.setAttribute('fill', 'none'); edge.setAttribute('stroke', 'rgba(90,110,150,.6)'); edge.setAttribute('stroke-width', '0.25');
                svg.appendChild(edge);
            }
        }
        var P = window.LabelSheets.page(fmtObj.page);
        var paper = S.label.print === 'sheet' ? sheetName(fmtObj) : String(S.label.print).toUpperCase();
        if (cap) cap.textContent = t(out.mode === 'front_back' ? 'sheet_cap_fb' : 'sheet_cap', { n: per, paper: paper, w: fmt(P.w), h: fmt(P.h) });
        /* «How much paper for this batch»: the question before buying a ream of
           sticker paper. A front + back label takes two sides per sheet. */
        var need = $('hl-batch-need'), batch = Math.floor(num(S.label.batch) || 0);
        if (need) need.textContent = batch > 0 ? t(out.mode === 'front_back' ? 'batch_need_fb' : 'batch_need', { n: batch, sheets: Math.ceil(batch / per), paper: paper }) : '';
    }

    function sheetName(f) {
        if (/^avery-/.test(f.id)) return 'Avery ' + f.id.slice(6).toUpperCase();
        if (/^div-/.test(f.id)) return 'A4 ÷ ' + f.cols * f.rows;
        return String(f.page).toUpperCase() + ' ' + f.cols + ' × ' + f.rows;
    }

    function exportIngPdf() {
        var res = computeIng();
        if (!res || !res.ok) return;
        var f = S.ing.format;
        var tb = ingItems(res, f, ingSize(res, f));
        var w = Math.ceil(tb.w), h = Math.ceil(tb.h);
        var fmtObj = pdfFormat(w, h);
        window.__LABEL_MAKER__ = window.__LABEL_MAKER__ || { assets: C.assets || {} };
        window.LabelPdf.build({ fmt: fmtObj, cells: [{ items: tb.items }] }).then(function (r) {
            return X.overlay(r.bytes, { fmt: fmtObj, cells: [{ ext: tb.ext }], title: 'Informasi Nilai Gizi', lang: 'id-ID' });
        }).then(function (bytes) {
            var nm = 'ing-' + (S.ing.src === 'lab' ? 'lab' : (S.ing.kind || 'produk'));
            nm = window.__outputName && window.__outputName.sanitize ? window.__outputName.sanitize(nm) : nm.replace(/[\/:*?"<>|]+/g, ' ');
            return window.__downloadFile(new Blob([bytes], { type: 'application/pdf' }), nm + '.pdf');
        }).then(function () {
            try { window.__aeToolComplete && window.__aeToolComplete({ kind: 'ing', format: f, src: S.ing.src }); } catch (_) {}
        }).catch(function (e) {
            if (window.__handleError) window.__handleError(e, 'halal_ing_pdf', { say: t('export_failed') });
        });
    }

    function copyIngText() {
        var res = computeIng();
        if (!res || !res.ok) return;
        var txt = L.ingText(res, S.ing.urt);
        var done = function (ok) {
            if (ok === false) { window.__toast && window.__toast(t('copy_failed'), 'error'); return; }
            window.__toast && window.__toast(t('copied'), 'success'); ae('ing_copy');
        };
        // the site's copy door (clipboard API, then the old execCommand path on WebViews)
        if (window.__copyText) Promise.resolve(window.__copyText(txt)).then(done, function () { done(false); });
        else if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(txt).then(done, function () { done(false); });
        else done(false);
    }

    /* ── drafts ────────────────────────────────────────────────────────── */

    var started = false;
    function touch() {
        started = true;
        if (editor) try { editor.touch(true); } catch (_) {}
    }

    function draftPayload() {
        var st = JSON.parse(JSON.stringify(S));
        return {
            state: st,
            files: logo && logo.blob ? [logo.blob] : [],
            label: S.label.name || S.ing.kind || t('draft_untitled_label'),
            meta: { w: S.label.w, h: S.label.h },
        };
    }

    function applyDraft(d) {
        var fresh = freshState();
        var st = d.state || {};
        S = fresh;
        ['tab'].forEach(function (k) { if (st[k]) S.tab = st[k]; });
        ['wiz', 'ing', 'label'].forEach(function (k) { if (st[k]) for (var n in st[k]) S[k][n] = st[k][n]; });
        logo = null;
        var f = d.files && d.files[0];
        if (f && f.size > 0) loadLogo(f);
        syncLabelInputs();
        renderWizard();
        showTab(S.tab || 'izin');
        return Promise.resolve([]);
    }

    function freshDraft() {
        S = freshState();
        logo = null;
        syncLabelInputs();
        renderWizard();
        showTab('izin');
    }

    /* ── wiring ────────────────────────────────────────────────────────── */

    function wire() {
        // tabs (arrow keys move between them, as a tablist should)
        var tabs = ['izin', 'ing', 'label'];
        tabs.forEach(function (k, i) {
            var b = $('hl-tab-' + k);
            if (!b) return;
            b.addEventListener('click', function () { showTab(k, true); });
            b.addEventListener('keydown', function (e) {
                if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
                var j = (i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length;
                showTab(tabs[j], true);
                $('hl-tab-' + tabs[j]).focus();
                e.preventDefault();
            });
        });
        document.querySelectorAll('[data-goto]').forEach(function (b) {
            b.addEventListener('click', function () { showTab(b.getAttribute('data-goto'), true); });
        });

        // wizard choices
        $('hl-p-izin').addEventListener('click', function (e) {
            var b = e.target.closest('[data-q]');
            if (!b) return;
            var q = b.getAttribute('data-q'), v = b.getAttribute('data-v');
            S.wiz[q] = v === 'true' ? true : (v === 'false' ? false : v);
            touch();
            renderWizard();
            ae('wizard', { q: q, v: v });
            funnel('wizard_answer');
        });
        $('hl-w-apply').addEventListener('click', applyWizardToLabel);

        // ING tab
        var ingRoot = $('hl-p-ing');
        ingRoot.addEventListener('click', function (e) {
            var pp = e.target.closest('[data-pop]');
            if (pp) { pickKind(pp.getAttribute('data-pop')); ae('ing_popular'); return; }
            var b = e.target.closest('[data-q]');
            if (b) {
                var q = b.getAttribute('data-q'), v = b.getAttribute('data-v');
                if (q === 'ingsrc') S.ing.src = v;
                if (q === 'unit') S.ing.unit = v;
                if (q === 'fmt') S.ing.format = v;
                touch(); renderIng(); return;
            }
            var sp = e.target.closest('[data-spp]');
            if (sp) { S.ing.spp = Number(sp.getAttribute('data-spp')); touch(); renderIng(); return; }
            var o = e.target.closest('#hl-kind-res [data-name]');
            if (o) pickKind(o.getAttribute('data-name'));
        });
        var kq = $('hl-kind');
        var activeOpt = -1;
        kq.addEventListener('input', function () { activeOpt = -1; renderKindResults(kq.value.trim()); });
        kq.addEventListener('change', function () { if (kq.value.trim() && kq.value.trim() !== S.ing.kind) kindNotFoundDiag(kq.value.trim()); });
        kq.addEventListener('keydown', function (e) {
            var list = $('hl-kind-res');
            var opts = list ? list.querySelectorAll('[data-name]') : [];
            if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
                if (!opts.length) return;
                activeOpt = (activeOpt + (e.key === 'ArrowDown' ? 1 : opts.length - 1)) % opts.length;
                opts.forEach(function (o, i) { o.setAttribute('aria-selected', i === activeOpt ? 'true' : 'false'); });
                kq.setAttribute('aria-activedescendant', opts[activeOpt].id);
                opts[activeOpt].scrollIntoView({ block: 'nearest' });
                e.preventDefault();
            } else if (e.key === 'Enter') {
                if (opts.length) { pickKind((opts[Math.max(0, activeOpt)]).getAttribute('data-name')); e.preventDefault(); }
            } else if (e.key === 'Escape') { list.hidden = true; }
        });
        ingRoot.addEventListener('input', function (e) {
            var el = e.target;
            var k = el.getAttribute('data-g');
            if (!k) return;
            if (k.indexOf('lab') === 0) S.ing.lab[+k.slice(3)] = el.value;
            else S.ing[k] = el.value;
            if (k === 'serving' && $('hl-serving-r')) { var n = num(el.value); if (n != null) $('hl-serving-r').value = n; }
            touch(); renderIng();
        });
        $('hl-serving-r').addEventListener('input', function (e) {
            S.ing.serving = String(e.target.value).replace('.', ',');
            $('hl-serving').value = S.ing.serving;
            touch(); renderIng();
        });
        $('hl-ing-pdf').addEventListener('click', exportIngPdf);
        $('hl-ing-copy').addEventListener('click', copyIngText);
        $('hl-ing-tolabel').addEventListener('click', function () {
            S.label.ingOn = true;
            if (!num(S.label.netValue) && num(S.ing.net)) { S.label.netValue = S.ing.net; S.label.netUnit = S.ing.unit; }
            syncLabelInputs();
            touch();
            showTab('label', true);
        });

        // label tab
        var lab = $('hl-p-label');
        lab.addEventListener('click', function (e) {
            var b = e.target.closest('[data-q]');
            if (b && !b.disabled) {
                var q = b.getAttribute('data-q'), v = b.getAttribute('data-v');
                var Lb = S.label;
                if (q === 'preset') {
                    Lb.preset = v;
                    if (v !== 'custom') { var p = v.split('x'); Lb.w = +p[0]; Lb.h = +p[1]; }
                } else if (q === 'lmode') Lb.mode = v;
                else Lb[q] = v;
                if (q === 'logoColor') repaintLogo();
                if (q === 'print' || q === 'lmode' || q === 'preset') ae(q, { v: v });
                syncLabelInputs();
                touch(); renderLabel(); return;
            }
            var a = e.target.closest('[data-al]');
            if (a) {
                var g = a.getAttribute('data-al'), off = S.label.alOff, i = off.indexOf(g);
                if (i >= 0) off.splice(i, 1); else off.push(g);
                touch(); renderLabel(); return;
            }
            var cx = e.target.closest('[data-cross]');
            if (cx) {
                var gg = cx.getAttribute('data-cross'), cr = S.label.cross, j = cr.indexOf(gg);
                if (j >= 0) cr.splice(j, 1); else cr.push(gg);
                touch(); renderLabel();
            }
        });
        var tmr = null;
        lab.addEventListener('input', function (e) {
            var el = e.target, k = el.getAttribute('data-f');
            if (!k) return;
            if (k === 'w' || k === 'h') {
                /* A size is a number of millimetres or nothing: «abc» reached
                   the preview as viewBox="0 0 abc 70" and NaN coordinates
                   (QA 23.10.2026). The last good size stays until the field
                   reads as a number; the field says it is not one. */
                var v = num(el.value);
                el.setAttribute('aria-invalid', v != null && v > 0 ? 'false' : 'true');
                if (v == null || !(v > 0)) return;
                S.label[k] = Math.max(15, Math.min(300, v));
            } else {
                S.label[k] = el.type === 'checkbox' ? el.checked : el.value;
            }
            touch();
            clearTimeout(tmr);
            tmr = setTimeout(renderLabel, 120);
        });
        lab.addEventListener('change', function (e) {
            var el = e.target, k = el.getAttribute('data-f');
            if (k && el.type === 'checkbox') { S.label[k] = el.checked; touch(); renderLabel(); }
            // leaving a size field: it shows the size the label really has (15–300 mm)
            if (k === 'w' || k === 'h') { el.value = fmt(S.label[k]); el.setAttribute('aria-invalid', 'false'); }
        });
        $('hl-export-pdf').addEventListener('click', exportLabel);
        var on = function (id, fn) { var el = $(id); if (el) el.addEventListener('click', fn); };
        on('hl-img', makeShot);
        on('hl-shot-share', function () { deliverShot('share'); });
        on('hl-shot-save', function () { deliverShot('save'); });
        on('hl-shot-close', function () { $('hl-shot').hidden = true; });
        on('hl-share-pdf', sharePdf);
        $('hl-sheet').addEventListener('change', function (e) {
            var f = e.target.value ? window.LabelSheets.byId(e.target.value) : null;
            var Lb = S.label;
            if (f) { Lb.sheet = f.id; Lb.w = f.w; Lb.h = f.h; Lb.preset = 'custom'; Lb.print = 'sheet'; ae('sheet', { id: f.id }); }
            else { Lb.sheet = ''; if (Lb.print === 'sheet') Lb.print = 'page'; }
            syncLabelInputs();
            touch(); renderLabel();
        });

        // the halal logo file — the shared uploader zone hands it over
        var zone = $('hl-logo-zone');
        var onFile = function (e) { var f = e && e.detail && (e.detail.file || (e.detail.files && e.detail.files[0])); if (f) loadLogo(f); };
        if (zone) {
            if (window.__bindUploaderFile) window.__bindUploaderFile(zone, function (f) { loadLogo(f && f.file ? f.file : f); });
            else zone.addEventListener('tool-uploader:file', onFile);
            zone.addEventListener('tool-uploader:clear', function () { logo = null; touch(); renderLabel(); });
        }
    }

    function boot() {
        if (!I || !R || !W || !L || !X || !LG || !window.LabelRender || !window.LabelSheets) return;
        L.useRules(R);
        measure = buildMeasure();
        wire();
        syncLabelInputs();
        renderWizard();
        showTab(S.tab);
        fontsReady().then(function () { measure.reset(); renderActive(); });
        if (window.__toolDraft && window.__toolDraft.editor) {
            try {
                editor = window.__toolDraft.editor({
                    slug: SLUG, root: 'hl-drafts', icon: '🏷️', openKey: 'hl-draft-open',
                    payload: draftPayload, apply: applyDraft, fresh: freshDraft,
                    started: function () { return started; },
                });
                editor.boot();
            } catch (_) { editor = null; }
        }
        try { window.__stage && window.__stage('ready'); } catch (_) {}
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
})();
